<template>
  <div class="flex flex-col gap-4">
    <TextHeader>Energiemarkt</TextHeader>
    <MessageComponent color="finance">
      <p>
        Bekijk onze
        <a
          href="https://www.repowered.nl/kennisbank/marktinzichten/"
          target="_blank"
          class="decoration-finance hover:text-finance underline decoration-2"
        >
          Maandelijkse Marktupdate</a
        >
        voor meer uitleg over ontwikkelingen op de energiemarkt.
      </p>
    </MessageComponent>
    <ToolbarComponent no-mode no-metering-point-menu />
    <DayAheadChartPanel :date-range="filterStore.dateRange" />
    <ImbalanceChartPanel :date-range="filterStore.dateRange" />
  </div>
</template>

<script setup>
import { startOfToday } from "date-fns"
import { TextHeader } from "@repowerednl/ui-component-library"
import DayAheadChartPanel from "@/components/panels/DayAheadChartPanel.vue"
import ImbalanceChartPanel from "@/components/panels/ImbalanceChartPanel.vue"
import ToolbarComponent from "@/components/navigation/ToolbarComponent.vue"
import useFilterStore from "@/stores/filterStore.js"
import MessageComponent from "@/components/information/MessageComponent.vue"
import useDefaultDateRange from "@/composables/useDefaultDateRange.js"

const filterStore = useFilterStore()

useDefaultDateRange([startOfToday(), startOfToday()])
</script>
